import Base from "../../../base";
import ReceiptCodeService from "../../../../services/running/paymentQrcode";
import Form from "../../../layout/form";

export default class ReceiptCodeAdd extends Base
{
    boot() {
        this.state = {
            model:{
                name:'',
                qrcode:'',
                status:1
            },
        }
    }

    componentDidMount() {

    }

    service() {
        return ReceiptCodeService;
    }

    render() {
        return (
            <Form
                model={this.state.model}
                fields={{
                    name:'名称',
                    qrcode:{name:'收款二维码', type:'image'},
                    status:{name:'状态', type:'radio', data: this.server.status}
                }}
            />
        );
    }
}
